import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { humanizeAuditValue } from './audit-catalog';

/**
 * Spanish labels for the raw identifiers stored in `audit_logs`. A value without a translation
 * falls back to a humanized form (never the snake_case id), so a freshly added action stays
 * readable until its label lands in `audit_labels.*`.
 */
export function useAuditLabels(): {
  moduleLabel: (raw: string) => string;
  actionLabel: (raw: string) => string;
  referenceLabel: (raw: string) => string;
  roleLabel: (raw: string) => string;
} {
  const { t } = useTranslation();
  return {
    moduleLabel: useCallback(
      (raw) => t(`audit_labels.module.${raw}`, { defaultValue: humanizeAuditValue(raw) }),
      [t],
    ),
    actionLabel: useCallback(
      (raw) => t(`audit_labels.action.${raw}`, { defaultValue: humanizeAuditValue(raw) }),
      [t],
    ),
    referenceLabel: useCallback(
      (raw) => t(`audit_labels.reference.${raw}`, { defaultValue: humanizeAuditValue(raw) }),
      [t],
    ),
    // Roles already have Spanish names in the users admin screen; reuse them.
    roleLabel: useCallback(
      (raw) => t(`users_admin.role_${raw}`, { defaultValue: humanizeAuditValue(raw) }),
      [t],
    ),
  };
}
